import v3ApiClient from "./client";

const AIRCRAFT_BASE_PATH = "/v3/aircraft";

export const aircraftAvailabilityApi = {
    listWindows: (aircraftId, params = {}) => v3ApiClient.get(`${AIRCRAFT_BASE_PATH}/${aircraftId}/availability-windows`, { params }),
    createWindow: (aircraftId, payload) => v3ApiClient.post(`${AIRCRAFT_BASE_PATH}/${aircraftId}/availability-windows`, payload),
    updateWindow: (aircraftId, windowId, payload) => v3ApiClient.put(`${AIRCRAFT_BASE_PATH}/${aircraftId}/availability-windows/${windowId}`, payload),
    deleteWindow: (aircraftId, windowId) => v3ApiClient.delete(`${AIRCRAFT_BASE_PATH}/${aircraftId}/availability-windows/${windowId}`),
    previewBatch: (aircraftId, payload) => v3ApiClient.post(`${AIRCRAFT_BASE_PATH}/${aircraftId}/availability-windows/batch-preview`, payload),
    createBatch: (aircraftId, payload) => v3ApiClient.post(`${AIRCRAFT_BASE_PATH}/${aircraftId}/availability-windows/batch-create`, payload),
};

export default aircraftAvailabilityApi;
